import { Form, Input, Switch, Row, Col, Select, Button } from 'antd';
import { useRef, useState, useEffect } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import getList from '../../../utilsTsx/universal/getList';
import { getService } from '../../system/WebUniversal';

const UserEdit = (props: any) => {
    const apiId = 'user';
    const { defaultService } = props;
    const [form] = Form.useForm(); //form 
    const ref = useRef<any>(undefined);

    const [roleData, setRoleData] = useState<any>();
    const [brandData, setBrandData] = useState<any>();
    const [userGroupData, setUserGroupData] = useState<any>();

    useEffect(() => {
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'role',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setRoleData(res.data);
                }
            });
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'brand',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setBrandData(res.data)
                }
            })
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'userGroup',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setUserGroupData(res.data)
                }
            })
    }, []);

    const extendProps: WebEditUniversalProps = {
        ...props,
        form,
        apiId,
        displayOptions: {
            width: 700
        },
        formOptions: {
            instance: form,
            children: (<Row gutter={[8, 0]}>
                <Col span={4}>
                    <Form.Item
                        label="ID"
                        name="id">
                        <Input disabled={true} />
                    </Form.Item>
                </Col>

                <Col span={10}>
                    <Form.Item
                        label="姓名"
                        name="userName"
                        rules={[{ required: true, message: '请输入姓名!' }]}>
                        <Input />
                    </Form.Item>
                </Col>

                <Col span={10}>
                    <Form.Item
                        label="品牌"
                        name="brandId">
                        <Select
                            placeholder="选择品牌"
                            showSearch={{
                                optionFilterProp: 'children',
                                filterOption: (input, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }}>
                            {getList.general(brandData, { itemName: 'brandName' })}
                        </Select>
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item
                        label="用户组"
                        name="userGroupId">
                        <Select
                            placeholder="用户组"
                            showSearch={{
                                optionFilterProp: 'children',
                                filterOption: (input, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }}>
                            {getList.general(userGroupData, { itemName: 'userGroupName' })}
                        </Select>
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item
                        label="手机"
                        name="phone">
                        <Input />
                    </Form.Item>
                </Col>

                <Col span={24}>
                    <Form.Item
                        label="角色"
                        name="roleIds" >
                        <Select
                            mode="multiple"
                            placeholder="选择角色"
                            showSearch={{
                                optionFilterProp: 'children',
                                filterOption: (input, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }}>
                            {getList.general(roleData, { itemName: 'roleName' })}
                        </Select>
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item
                        label="地址"
                        name="address">
                        <Input />
                    </Form.Item>
                </Col>

                <Col span={4}>
                    <Form.Item
                        label="管理员"
                        name="isAdmin"
                        valuePropName="checked"
                        initialValue={false}>
                        < Switch checked={false}
                            disabled={false}
                            checkedChildren="是"
                            unCheckedChildren="否" />
                    </Form.Item>
                </Col>

                <Col span={4}>
                    <Form.Item
                        label="状态"
                        name="isUse"
                        valuePropName="checked"
                        initialValue={true}>
                        < Switch checked={true}
                            checkedChildren="启用"
                            unCheckedChildren="关闭" />
                    </Form.Item>
                </Col>

            </Row >)
        }
    };

    return (<WebEditUniversal ref={ref} {...extendProps} />)
}

export default UserEdit;